// Session graphics spend (USD), persisted in localStorage for the discreet meter.
const STORAGE_KEY = 'specimen-observer:gfx-spend-usd';

let gfxSpendUsd = 0;
const listeners = new Set<() => void>();

function parseStored(raw: string | null): number {
  if (raw == null || raw === '') return 0;
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 0) return 0;
  return Math.round(n * 100) / 100;
}

function loadFromStorage(): number {
  try {
    return parseStored(localStorage.getItem(STORAGE_KEY));
  } catch {
    return 0;
  }
}

function persist(value: number): void {
  gfxSpendUsd = value;
  try {
    localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    // keep in-memory total for this page load
  }
}

gfxSpendUsd = loadFromStorage();

export function getGfxSpendUsd(): number {
  return gfxSpendUsd;
}

export function addGfxSpendUsd(amount: number): void {
  if (!Number.isFinite(amount) || amount < 0) return;
  persist(Math.round((gfxSpendUsd + amount) * 100) / 100);
  listeners.forEach((l) => l());
}

export function subscribeGfxSpend(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
